<div class="block-schedule__top">
    <ridango-ui-back-button (onBack)="back()">{{'LOCAL_BTN_BACK' | translate}}
    </ridango-ui-back-button>

    <div class="flex-center">
        <span class="flex-center route-list--number" role="text" aria-label="[MISSING]SCHEDULE_ARIA_LABEL_ROUTE_NAME} 8">{{routeName}}</span>
        <div class="flex flex-column flex1 route-detail-description">
            <h1 class="remove-margin">{{selectedStop?.stop_name}}</h1>
            <p class="remove-margin">{{directionName}}</p>
        </div>
    </div>
</div>

<div class="block-schedule__bottom" [attr.aria-busy]="!(tripLoading$ | async)">
    <ridango-ui-basic-loading-spinner *ngIf="tripLoading$ | async"
        [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
    </ridango-ui-basic-loading-spinner>

    <ng-container *ngIf="!(tripLoading$ | async)">
        <ul class="remove-bullets route-list">
            <li *ngFor="let stop of (routeTripStops$ | async)">
                <a class="link link--no-line link--no-hover flex-center full-width min-height-50"
                    [ngClass]="{ 'bold': selectedStop?.stop_sequence === stop.stop_sequence }">
                    <span class="flex-center route-list--stop"></span>
                    <span class="line-intermediate"></span>
                    <div class="flex flex1 position-relative min-height-60 padding-10">
                        <span class="flex1 margin-right-10 align-self-center" role="text">{{stop.stop_name}}</span>
                        <span>{{stop.departure_time | timeFromString:'hh:mm'}}</span>
                        <div class="route-list--hr"></div>
                    </div>
                </a>
            </li>
        </ul>
    </ng-container>
</div>